import React from 'react'
import { Button } from '@/shared/ui/Button/Button'
import { ReactComponent as Circles } from '@/shared/assets/circles.svg'
import cls from './ContactBanner.module.scss'
import { scrollIntoView } from '@/shared/lib/utils/scrollIntoView'

export const ContactBanner = () => {
    return (
        <div className={cls.container}>
            <aside className={cls.ContactBanner}>
                <Circles className={cls.Circles} />
                <h3>Do you need a special offer?</h3>
                <Button
                    onClick={() => scrollIntoView('contact')}
                    variant="primary"
                >
                    Contact Us
                </Button>
            </aside>
        </div>
    )
}
